import styled from '@emotion/styled'
import { ActionSheetDropdownItem as Original } from '@instacart/ids-core'
import { colors } from '../foundation'

export const ActionSheetDropdownItem = styled(Original)({
  '&:hover': {
    background: colors.GRAYSCALE.X10,
  },
})
